/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { RegionSearchPublic } from './RegionSearchPublic'
import {
  RegionSearchPublicFromJSON,
  RegionSearchPublicFromJSONTyped,
  RegionSearchPublicToJSON,
} from './RegionSearchPublic'

/**
 *
 * @export
 * @interface EnvelopedRegionListRegionSearchPublic
 */
export interface EnvelopedRegionListRegionSearchPublic {
  /**
   *
   * @type {Array<RegionSearchPublic>}
   * @memberof EnvelopedRegionListRegionSearchPublic
   */
  body: Array<RegionSearchPublic>
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedRegionListRegionSearchPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedRegionListRegionSearchPublic interface.
 */
export function instanceOfEnvelopedRegionListRegionSearchPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedRegionListRegionSearchPublicFromJSON(
  json: any,
): EnvelopedRegionListRegionSearchPublic {
  return EnvelopedRegionListRegionSearchPublicFromJSONTyped(json, false)
}

export function EnvelopedRegionListRegionSearchPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedRegionListRegionSearchPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: (json['body'] as Array<any>).map(RegionSearchPublicFromJSON),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedRegionListRegionSearchPublicToJSON(
  value?: EnvelopedRegionListRegionSearchPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: (value.body as Array<any>).map(RegionSearchPublicToJSON),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
